import React, { useState } from 'react'
import Rating from "react-rating-stars-component";
import ProgressBar from "@ramonak/react-progress-bar";
const Ratings = () => {
    const [rating, setRating] = useState(3.5);
    const ratingChanged = (newRating) => {
        setRating(newRating);
        console.log(`New rating: ${newRating}`);
    };
    const [subrating, setsubrating] = useState(0);
    const subratingChanged = (newRating) => {
        setsubrating(newRating);
        console.log(`New rating: ${newRating}`);
    };
    return (
        <div className='ratings-bg pb-40'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-5'>
                        <div className='average-rating-bg'>
                            <h2>Average Ratings</h2>
                            <div className="stars-sec">
                                <h1>4.5</h1>
                                <div className='star-inner'>
                                    <Rating
                                        count={5} 
                                        value={rating}
                                        onChange={ratingChanged} 
                                        isHalf={true}
                                        size={26}
                                        activeColor="#ffb20d"
                                        edit={false}
                                    />
                                    <p>{rating}</p>
                                </div>
                            </div>
                            <div className='prograssbar-inner'>
                                <p>5</p>
                                <ProgressBar completed={90} maxCompleted={100} className='progress' height='13px' bgColor='#227070' />
                                <p>90%</p>
                            </div>
                            <div className='prograssbar-inner'>
                                <p>4</p>
                                <ProgressBar completed={70} maxCompleted={100} className='progress' height='13px' bgColor='#227070' />
                                <p>70%</p>
                            </div>
                            <div className='prograssbar-inner'>
                                <p>3</p>
                                <ProgressBar completed={60} maxCompleted={100} className='progress' height='13px' bgColor='#227070' />
                                <p>60%</p>
                            </div>
                            <div className='prograssbar-inner'>
                                <p>2</p>
                                <ProgressBar completed={30} maxCompleted={100} className='progress' height='13px' bgColor='#227070' />
                                <p>30%</p>
                            </div>
                            <div className='prograssbar-inner'>
                                <p>1</p>
                                <ProgressBar completed={10} maxCompleted={100} className='progress' height='13px' bgColor='#227070' />
                                <p>10%</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-7'>
                        <div className='submit-review-bg'>
                            <h2>Submit Review</h2>
                            <p>Add Your Ratings <sup>*</sup></p>
                            <Rating
                                count={5} 
                                value={subrating} 
                                onChange={subratingChanged} 
                                isHalf={true}
                                size={26} 
                                activeColor="#ffb20d"
                                edit={true} 
                            />
                            <form>
                            <p className='write-review'>Write Your Review <sup>*</sup></p>
                            <textarea type='message' placeholder='Message...' required></textarea>

                            <div className='review-submit-btn'>
                                <button type='submit'>Submit</button>
                            </div>
                            </form>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default Ratings